import React from "react";
import { FaStar } from "react-icons/fa";

const Review = () => {
  return (
    <>
      <div style={{ marginTop: "4vh" }}></div>
      <div className="review_box">
        <div className="review_container">
          <div className="image_box_reviw">
            <img src="/assets/logo/logo.jpg" alt="logo" />
          </div>
          <div className="revies_data">
            <span className="Info_rs_header">Ashima</span>
            <span className="info_phera_note">Oct 03,2024</span>
            <span
              className="Info_rs_header"
              style={{
                textAlign: "center",
              }}
            >
              <FaStar color="gold" />3
            </span>
          </div>
        </div>
      </div>
      <div className="review_box">
        <div className="review_container">
          <div className="image_box_reviw">
            <img src="/assets/logo/logo.jpg" alt="logo" />
          </div>
          <div className="revies_data">
            <span className="Info_rs_header">Ashima</span>
            <span className="info_phera_note">Oct 03,2024</span>
            <span
              className="Info_rs_header"
              style={{
                textAlign: "center",
              }}
            >
              <FaStar color="gold" />3
            </span>
          </div>
        </div>
      </div>
      <div className="review_box">
        <div className="review_container">
          <div className="image_box_reviw">
            <img src="/assets/logo/logo.jpg" alt="logo" />
          </div>
          <div className="revies_data">
            <span className="Info_rs_header">Ashima</span>
            <span className="info_phera_note">Oct 03,2024</span>
            <span
              className="Info_rs_header"
              style={{
                textAlign: "center",
              }}
            >
              <FaStar color="gold" />3
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Review;
